module.exports = __webpack_public_path__ + "img/2013-12_bloomberg_a.dde094c2.png";